import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, CanActivateChild } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AuthService } from '../interceptor/auth.service';
import { Constants } from 'src/app/app.constants';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate, CanActivateChild {

  constructor(private router: Router, private auth: AuthService) { }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (this.auth.isLoggedIn()) {
      return true;
    }

   // this.router.navigate(['login'], { queryParams: { msg: "Your Session has Expired! Please Sign In Again." } });
    // this.router.navigate(['login']);
    window.location.href=Constants.LOGIN_URL;
  }

  canActivateChild(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    let feature = next.data.feature;
    let subFeature = next.data.feature;
    if (!feature) {
      return true;
    }else{
        return false;
    }
  
  }

}
